'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_utils_NewtypeMass$$anon$3(outer) {
  this.aYg = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.aYg = outer;
}
export { $c_Lapp_utils_NewtypeMass$$anon$3 as $c_Lapp_utils_NewtypeMass$$anon$3 };
$p = $c_Lapp_utils_NewtypeMass$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_utils_NewtypeMass$$anon$3;
/** @constructor */
function $h_Lapp_utils_NewtypeMass$$anon$3() {
}
export { $h_Lapp_utils_NewtypeMass$$anon$3 as $h_Lapp_utils_NewtypeMass$$anon$3 };
$h_Lapp_utils_NewtypeMass$$anon$3.prototype = $p;
$p.bYS = (function(_$2) {
  var this$1 = this.aYg;
  var e$proxy2 = this$1.iu(_$2);
  if ((e$proxy2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), (("Expected Right, got Left(" + e$proxy2.bj) + ")"));
  }
  if ((e$proxy2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    return e$proxy2.aI;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(e$proxy2);
});
$p.ak = (function(src) {
  return this.bYS(src);
});
var $d_Lapp_utils_NewtypeMass$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_utils_NewtypeMass$$anon$3, "app.utils.NewtypeMass$$anon$3", ({
  Iv: 1,
  V: 1,
  U: 1
}));
export { $d_Lapp_utils_NewtypeMass$$anon$3 as $d_Lapp_utils_NewtypeMass$$anon$3 };
//# sourceMappingURL=app.utils.-Newtype-Mass$$anon$3.js.map
